import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithMonstaX = () => {
  return (
    <KpopStudyPageTemplate
      groupName="MONSTA X"
      groupNameDisplay="MONSTA X"
      fandomName="Monbebes"
      seoTitle="Study With MONSTA X - MONSTA X Study Rooms"
      seoDescription="Study with MONSTA X fans worldwide. Join Monbebes in virtual study rooms with MONSTA X playlists."
      seoKeywords="study with monsta x, monsta x study room, monbebe study, kpop study room"
      canonicalUrl="/study-with-monsta-x/"
      heroDescription="Join a global community of Monbebes who combine their passion for MONSTA X with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://www.monstax-e.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">MONSTA X</a> is a South Korean boy band formed through the reality show No.Mercy in 2015. Known for their powerful performances and dynamic music.
          </p>
          <p>
            MONSTA X's fanbase, known as Monbebe, shares a special bond with the group. Follow them on <a href="https://www.instagram.com/official_monsta_x/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/OfficialMonstaX" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@MONSTAX" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          MONSTA X fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/4TnGh5PKbSjpYqpIdlW5nz" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">MONSTA X's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "MONSTA X Study Playlists", desc: "Curated playlists featuring MONSTA X's powerful tracks to keep you motivated." },
        { title: "Connect with Monbebe", desc: "Meet fellow Monbebes from around the world who share your passion." },
        { title: "Intense Study Rooms", desc: "Study rooms with MONSTA X-inspired energy and focus." },
        { title: "All In Sessions", desc: "Go all in on your studies with other Monbebes worldwide." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of MONSTA X can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://www.monstax-e.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@MONSTAX" },
        { name: "Instagram", url: "https://www.instagram.com/official_monsta_x/" },
        { name: "X (Twitter)", url: "https://twitter.com/OfficialMonstaX" },
        { name: "Spotify", url: "https://open.spotify.com/artist/4TnGh5PKbSjpYqpIdlW5nz" },
      ]}
      youtubeVideos={[
        { id: "PGCFaZIeB3k", title: "MONSTA X - FANTASIA M/V" },
        { id: "ySxIjeCScgY", title: "MONSTA X - Love Killa M/V" },
        { id: "-SQ3pxqLwdI", title: "MONSTA X - GAMBLER M/V" },
        { id: "wen-xHRm6D4", title: "MONSTA X - Rush Hour M/V" },
        { id: "wLIoHPVKTQ8", title: "MONSTA X - Shoot Out M/V" },
        { id: "FZ9lJ5ctd0s", title: "MONSTA X - JEALOUSY M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@MONSTAX"
      youtubeChannelName="MONSTA X"
    />
  );
};

export default StudyWithMonstaX;
